// ─────────────────────────────────────────────
// PLAN → INTEGER MAP
// ─────────────────────────────────────────────
export const PLAN_MAP = {
  free: 0,
  standard: 1,
  premium: 2,
  enterprise: 3,
};

// ─────────────────────────────────────────────
// CURRENCY HELPERS
// ─────────────────────────────────────────────
export const getCurrencySymbol = (currency) => (currency === 'INR' ? '₹' : '$');

export const getActivePrice = (plan, currency) =>
  currency === 'INR' ? plan.priceMonthlyINR : plan.priceMonthlyUSD;

export const getActivePerUser = (plan, currency) =>
  currency === 'INR' ? plan.perUserINR : plan.perUserUSD;

export const getBasePrice = (plan, currency) =>
  currency === 'INR' ? plan.basePriceINR : plan.basePriceUSD;

export const getPerUser = (plan, currency) =>
  currency === 'INR' ? plan.perUserINR : plan.perUserUSD;

// ─────────────────────────────────────────────
// CALCULATION HELPERS
// ─────────────────────────────────────────────
export const calculateTotalPrice = ({ basePrice, perUser, enableUsers, userCount }) => {
  const effectiveUserCount = enableUsers ? userCount : 0;
  return Number(basePrice || 0) +
       Number(effectiveUserCount || 0) * Number(perUser || 0);
};

export const getEffectiveUserCount = (enableUsers, userCount) => (enableUsers ? userCount : 0);

// ─────────────────────────────────────────────
// PLAN HELPERS
// ─────────────────────────────────────────────
export const isCustomPlan = (plan) =>
  plan.priceMonthlyINR === 'Custom' ||
  plan.priceMonthlyUSD === 'Custom' ||
  plan.priceMonthly === 'Custom';

export const isSamePlanCheck = (currentPlanName, selectedPlanName) =>
  currentPlanName?.toUpperCase() === selectedPlanName?.toUpperCase();

export const getAllFeatures = (plan) => [
  ...(plan.includedFeatures || []).map((f) => ({ text: f, included: true })),
  ...(plan.excludedFeatures || []).map((f) => ({ text: f, included: false })),
];
